import { Datasource, IDatasource } from 'utility-ng-kernel';
import { APMmFavoriteCourse } from '../builders/ap_mm_favorite_course_builder';

export interface IAPMmFavoriteCoursesDatasource extends IDatasource<APMmFavoriteCourse> {}

angular.module('capability-ng-academic-planner').factory('ngAPMmFavoriteCoursesDatasource', () => {
  return new Datasource<APMmFavoriteCourse>({
    builderType: APMmFavoriteCourse
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/datasources/ap_mm_favorite_course_datasource.ts